import { CollapsibleGroup } from './CollapsibleGroup';
import type { ITablesGroupProps } from './ITablesGroupProps';
import { TableMenuItem } from './TableMenuItem';

/**
 * Секція «Таблиці» меню модуля: таблиці без власного розділу з лічильниками; спроєктовані — приглушені, відкривають «Записи й форми» з
 * підсвіченим типом (TableMenuItem).
 * Розгорнута типово (defaultOpen) або коли поточна таблиця — тут; вибір користувача зберігається для модуля.
 */
export function TablesGroup({ ws, moduleKey, recordTypes, current, groupedType, title, defaultOpen, openState }: ITablesGroupProps) {
  if (!recordTypes.length) return null;
  const fallback = defaultOpen || recordTypes.some((r) => r.key === current && r.key !== groupedType);
  return (
    <CollapsibleGroup title={title} open={openState.isOpen('tables', fallback)} onToggle={() => openState.toggle('tables', fallback)}>
      {recordTypes.map((r) => <TableMenuItem key={r.key} ws={ws} moduleKey={moduleKey} rt={r} active={r.key === current && r.key !== groupedType} />)}
    </CollapsibleGroup>
  );
}
